function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 0C4.082 0 0.5 3.582 0.5 8C0.5 12.418 4.082 16 8.5 16C12.918 16 16.5 12.418 16.5 8C16.5 3.582 12.918 0 8.5 0ZM8.5 12.1667C8.04 12.1667 7.66667 11.7933 7.66667 11.3333C7.66667 10.8733 8.04 10.5 8.5 10.5C8.96067 10.5 9.33333 10.8733 9.33333 11.3333C9.33333 11.7933 8.96067 12.1667 8.5 12.1667ZM9.80733 8.21467C9.20467 8.86467 9.176 9.224 9.184 9.66667H7.84733C7.84267 8.68333 7.86067 8.25 8.80133 7.35467C9.18333 6.992 9.48467 6.70467 9.44267 6.14067C9.404 5.604 8.956 5.32333 8.53267 5.32333C8.06 5.32333 7.50733 5.67467 7.50733 6.66533H6.16733C6.16733 5.06533 7.10667 4.032 8.56067 4.032C9.25133 4.032 9.85533 4.258 10.2607 4.66867C10.6407 5.054 10.8373 5.58333 10.83 6.20067C10.8193 7.12267 10.2587 7.728 9.80733 8.21467Z"
});

function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.6272e5eeb4f1949a35bf98df47c3e854.svg";
export { ForwardRef as ReactComponent };